module.exports = __webpack_public_path__ + "img/1481919144.67eae8d0.jpg";